module.exports = __webpack_public_path__ + "img/img0-m.b69a2b30.png";